import type { MinMax } from '../../core/types/min-max.js';
import { getRelativeValue } from '../../core/utils/get-relative-value.js';
import { safeGet } from '../../core/utils/safe-get.js';
import type {
  AxisIdToScaleDomain,
  XYChartAxisInternal,
} from '../types/xy-chart-internals.js';

export const toRelative = (currentValue: number, minMaxDomain: MinMax) => {
  return getRelativeValue(
    currentValue,
    Math.max(Math.abs(minMaxDomain.max), Math.abs(minMaxDomain.min)),
    true,
  );
};

export const toAbsolute = (currentValue: number, minMaxDomain: MinMax) => {
  const isNegativeValue = currentValue < 0;
  const total = Math.max(
    Math.abs(minMaxDomain.max),
    Math.abs(minMaxDomain.min),
  );
  const math = Math[isNegativeValue ? 'ceil' : 'floor'];
  return math(total * currentValue) / 100;
};

export const getRelativeAccessor = (
  axis: XYChartAxisInternal,
  domain: MinMax,
): ((value: number) => number) | undefined => {
  if (axis.isRelative) {
    return (value: number) => toRelative(value, domain);
  }
  return undefined;
};

export const relAccessor = (
  axis: XYChartAxisInternal,
  axisIdToScaleDomain: AxisIdToScaleDomain,
) => {
  const minMaxDomain = safeGet(axisIdToScaleDomain, axis.id) as MinMax;
  return getRelativeAccessor(axis, minMaxDomain);
};

export type BinDomain = MinMax | Set<string>;
